import { POST, GET } from '@/utils/request'
import Api from './url'

export const getRuleInfoData = async (params: object) => {
  return await GET({
    url: Api.getRuleInfoData,
    params,
    showError: false
  })
}
